import {DayOffReasonEnum} from "../../generated";
import {UnreachableCaseError} from "ts-essentials";

export const formatDayOffReasonEnum = (type: DayOffReasonEnum) => {
    switch (type) {
        case DayOffReasonEnum.Holiday:
        case DayOffReasonEnum.Sick:
            return type;
        case DayOffReasonEnum.ProfessionalServices:
            return 'Professional services'
        case DayOffReasonEnum.SpecialRequest:
            return 'Special request';
        case DayOffReasonEnum.WorkingFromHome:
            return 'Working from home';
        default:
            throw new UnreachableCaseError(type);
    }
}